import React from 'react'

import { Card, Button } from '_zari/core'

import { CodigosTransaccionesConstant } from 'constants/index'

import * as FormGroups from './formGroups'

const TransaccionesFormGroup = ({
  transaccion,
  transacciones,
  permisosxTransaccion,
  setFieldValue,
  permisosSeleccionados
}) => {
  const onChange = React.useCallback(
    val => {
      if (permisosSeleccionados.find(x => x === val)) {
        const permisos = permisosSeleccionados.filter(y => y !== val)
        setFieldValue('permisos', permisos)
      } else {
        let permisos = permisosSeleccionados
        permisos.push(val)
        setFieldValue('permisos', permisos)
      }
    },
    [permisosSeleccionados, setFieldValue]
  )
  const clickEliminarTransaccion = React.useCallback(() => {
    let transaccionesNuevas = transacciones.filter(x => x !== transaccion)
    let permisosNuevos = permisosSeleccionados.filter(x => !x.startsWith(transaccion))
    setFieldValue('transacciones', transaccionesNuevas)
    setFieldValue('permisos', permisosNuevos)
  }, [transacciones, setFieldValue, transaccion, permisosSeleccionados])

  return (
    <Card>
      <Card.Header>
        <Card.Title>
          {CodigosTransaccionesConstant.__dictionary[transaccion]
            ? CodigosTransaccionesConstant.__dictionary[transaccion].nombre
            : '--'}
        </Card.Title>
        <Button color='primary' onClick={clickEliminarTransaccion}>
          Eliminar
        </Button>
      </Card.Header>
      <Card.Body>
        {permisosxTransaccion.map(val => (
          <FormGroups.PermisoFormGroup
            key={val}
            val={val}
            checked={permisosSeleccionados.some(x => x === val)}
            onChange={() => onChange(val)}
          />
        ))}
      </Card.Body>
    </Card>
  )
}

export default React.memo(TransaccionesFormGroup)
